import * as React from 'react';

import SidebarContainer from '../components/Sidebar';
import { ModalWithHoc } from '../../../design-system/modal/Modal';
import { SidebarWithHoc } from '../../../design-system/sidebar/Sidebar';
import ModalContainer from '../../../modules/common/components/Modal';
import PopupContainer from '../components/Popup';
import Main from './Main';
import { Box } from '../../../design-system';

type Props = {
  children: React.ReactNode;
};

const UIComponent = ({ children }: Props) => (
  <>
    <Box id="snackbars" />
    <ModalContainer />
    <ModalWithHoc />
    <PopupContainer />
    <SidebarContainer />
    <SidebarWithHoc />
    <Main>{children}</Main>
  </>
);

export default UIComponent;
